module.exports = __webpack_public_path__ + "static/media/cinema.ef2323d0.png";